import { useChatContext } from './ChatContext';
import { getFriendlyErrorMessage, getLabel } from '@/i18n/maps';
import type { ChatMessage } from './messages';

/**
 * 一条发送失败的消息。紧跟在用户气泡后面，重试按钮和「哪条消息失败了」
 * 绑定在一起——底部 banner 做不到这一点，多轮出错时用户会分不清。
 */
export function FailedBubble({
  message,
}: {
  message: Extract<ChatMessage, { type: 'failed' }>;
}): JSX.Element {
  const { locale, onRetryMessage, sending } = useChatContext();
  const text = getFriendlyErrorMessage(message.code, undefined, locale);

  return (
    <div
      role="alert"
      className="cal-failed-reply tw-rounded-2xl tw-rounded-tl-md tw-p-3 tw-bg-red-50 tw-border tw-border-red-200 tw-flex tw-items-center tw-justify-between tw-gap-3"
    >
      <span className="tw-text-[13px] tw-text-red-700 tw-leading-snug">{text}</span>
      {message.retriable && onRetryMessage && (
        <button
          type="button"
          onClick={() => onRetryMessage(message.id)}
          disabled={sending}
          className="tw-flex-shrink-0 tw-px-3 tw-py-1.5 tw-rounded-full tw-text-[12px] tw-font-semibold tw-text-white tw-bg-cal-green-500 hover:tw-bg-cal-green-700 tw-transition-colors disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
        >
          {sending ? getLabel('retrying', locale) : getLabel('retry', locale)}
        </button>
      )}
    </div>
  );
}
